import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            // Serve cached data instantly on remount/navigation, refresh in
            // the background. Conservative window keeps the UI fresh.
            staleTime: 30_000,
            gcTime: 5 * 60_000,
            retry: 1,
        },
    },
});
